class slideSwiperWrapper extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.productSwiper();
    this.init();
  }
  productSwiper(){
    let width = window.innerWidth;
    let swiperInfo = this.querySelector('#swiperInfo') && JSON.parse(this.querySelector('#swiperInfo').textContent);
    let autoplay = swiperInfo.is_autoplay ? {
      disableOnInteraction: false,
      delay: swiperInfo.autoplay_speed * 1000,
      stopOnLastSlide: false,
    } : false;
    this.slideSwiper = new Swiper(`.slide-swiper-wrapper-${this.sectionId }`,{
      loop:swiperInfo.is_loop,
      autoplay,
      spaceBetween: swiperInfo.swiper_space,
      slidesPerView: width <=  767 ? swiperInfo.swiper_num_m : (width >  767 && width < 1024 ? swiperInfo.swiper_num_t : swiperInfo.swiper_num),
      slidesPerGroup:swiperInfo.slidesPerGroup ? swiperInfo.swiper_num : 1,
      observer: true,
      observeParents: true, 
      observeSlideChildren: true,
      // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev',
      // }
    })
    let prevEl = document.querySelector(`#prevButton${this.sectionId}`);
    let nextEl = document.querySelector(`#nextButton${this.sectionId}`);
    let that = this;
    prevEl.onclick = function(){
      that.slideSwiper.slidePrev(1000,false)
    }
    nextEl.onclick = function(){
      that.slideSwiper.slideNext(1000,false)
    }
    this.slideSwiper.el.onmouseover = function(){
      prevEl.classList.remove('hide');
      nextEl.classList.remove('hide');
    }
    this.slideSwiper.el.onmouseout = function(){
      prevEl.classList.add('hide');
      nextEl.classList.add('hide');
    }
    this.slidePopupSwiper = new Swiper(`.slide-swiper-popup-wrapper`,{
      loop:true,
      observer: true,
      observeParents: true, 
      observeSlideChildren: true,
      navigation: {
        nextEl: '.swiper-popup-button-next',
        prevEl: '.swiper-popup-button-prev',
      }
    })
  }
  init(){
    let popupWrapper = document.querySelector(`#slidePopup${this.sectionId}`)
    let icon = popupWrapper.querySelector('.close-icon')
    this.querySelectorAll('.slide-swiper-wrapper img') && this.querySelectorAll('.slide-swiper-wrapper img').forEach((item)=>{
      item.onclick = ()=>{
        let index = item.getAttribute('data-index');
        this.slidePopupSwiper.slideTo(index,0,false);
        popupWrapper.setAttribute('open','');
      }
    })
    icon.onclick = ()=>{
      popupWrapper.removeAttribute('open');
    }
  }
}
customElements.define('slide-swiper-wrapper', slideSwiperWrapper);
class productSwiperCollect extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.productSwiper()
  }
  productSwiper(){
    let width = window.innerWidth;
    let swiperInfo = this.querySelector('#swiperProductInfo') && JSON.parse(this.querySelector('#swiperProductInfo').textContent);
    let autoplay = swiperInfo.is_autoplay ? {
      disableOnInteraction: false,
      delay: swiperInfo.autoplay_speed * 1000,
      stopOnLastSlide: false,
    } : false;
    this.productCollectSwiper = new Swiper(`.product-swiper-collect-wrapper-${this.sectionId }`,{
      loop:swiperInfo.is_loop,
      autoplay,
      spaceBetween: swiperInfo.swiper_space,
      slidesPerView: width <=  767 ? swiperInfo.swiper_num_m : (width >  767 && width < 1024 ? swiperInfo.swiper_num_t : swiperInfo.swiper_num),
      slidesPerGroup:swiperInfo.slidesPerGroup ? swiperInfo.swiper_num : 1,
      observer: true,
      observeParents: true, 
      observeSlideChildren: true,
      // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev',
      // }
    })
    let prevEl = document.querySelector(`#prevButton${this.sectionId}`);
    let nextEl = document.querySelector(`#nextButton${this.sectionId}`);
    let that = this;
    prevEl.onclick = function(){
      that.productCollectSwiper.slidePrev(1000,false)
    }
    nextEl.onclick = function(){
      that.productCollectSwiper.slideNext(1000,false)
      
    }
    this.productCollectSwiper.el.onmouseover = function(){
      prevEl.classList.remove('hide');
      nextEl.classList.remove('hide');
    }
    this.productCollectSwiper.el.onmouseout = function(){
      prevEl.classList.add('hide');
      nextEl.classList.add('hide');
    }
  }
  init(){
    
  }
}
customElements.define('product-swiper-collect', productSwiperCollect);
class productListSwiper extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.productSwiper()
  }
  productSwiper(){
    let width = window.innerWidth;
    let that = this;
    let prevEl = document.querySelector(`#prevButton${this.sectionId}`);
    let nextEl = document.querySelector(`#nextButton${this.sectionId}`);
    let swiperInfo = this.querySelector(`#swiperProductInfo${this.sectionId}`) && JSON.parse(this.querySelector(`#swiperProductInfo${this.sectionId}`).textContent);
    console.log(this.querySelector(`#swiperProductInfo${this.sectionId}`))
    let autoplay = swiperInfo.is_autoplay ? {
      disableOnInteraction: false,
      delay: swiperInfo.autoplay_speed * 1000,
      stopOnLastSlide: false,
    } : false;
    this.productListSwiper = new Swiper(`.product-list-swiper-wrapper-${this.sectionId }`,{
      loop:swiperInfo.is_loop,
      autoplay,
      spaceBetween: swiperInfo.swiper_space,
      slidesPerView: width <=  767 ? swiperInfo.swiper_num_m : (width >  767 && width < 1024 ? swiperInfo.swiper_num_t : swiperInfo.swiper_num),
      slidesPerGroup:swiperInfo.slidesPerGroup ? swiperInfo.swiper_num : 1,
      observer: true,
      observeParents: true, 
      observeSlideChildren: true,
       noSwiping: true,
    })
    prevEl.onclick = function(){
      that.productListSwiper.slidePrev(500,false);
       if(that.productListSwiper.realIndex == 0){
          prevEl.style.display = 'none';
           nextEl.style.display = 'flex';
        }
        else{
          prevEl.style.display = 'flex';
          nextEl.style.display = 'flex';
        }
    }
    nextEl.onclick = function(){
      that.productListSwiper.slideNext(500,false);
      if(that.productListSwiper.realIndex == that.productListSwiper.slides.length - 1){
          nextEl.style.display = 'none';
          prevEl.style.display = 'flex';
      }
      else{
        prevEl.style.display = 'flex';
      }
    }
  }
}
customElements.define('swiper-product-list', productListSwiper);
